import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';
import isNil from 'utils/isNil';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import useMagazineDownloadImages from 'hooks/useMagazineDownloadImages';
import WebsiteImage from 'components/WebsiteImage';
const MagazineDownload = ({ className, width, type }) => {
  const pageImages = useMagazineDownloadImages();

  let MagazineDownloadImg, MagazineDownloadImg1;
  pageImages.forEach(imageItem => {
    if (imageItem.node.internalName === 'Magazine Download Img') {
      MagazineDownloadImg = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'Magazine Download Img 1') {
      MagazineDownloadImg1 = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    }
  });

  return (
    <MainDiv width={width} className={className}>
      <div className="digital-asset-container">
        <WebsiteImage
          src={type == 'podcast' ? MagazineDownloadImg1 : MagazineDownloadImg}
          className="magazine-download--logo"
          alt="Hire a Tech Checklist"
        />
      </div>
      <Title className="digital-asset-title">
        {type == 'podcast' ? 'Download our latest digital magazine.' : 'Hiring Techs? We Can help!'}
      </Title>
      <Button
        type="secondary"
        width="200px"
        height="50px"
        shadow={true}
        to="/guides/hiring-techs"
        className="magazine-download--button"
      >
        {type == 'podcast' ? 'Download' : 'Download Now'}
      </Button>
    </MainDiv>
  );
};

MagazineDownload.propTypes = {
  width: PropTypes.string,
};

MagazineDownload.defaultProps = {
  width: '100%',
};
export default MagazineDownload;

const MainDiv = styled.div`
  width: ${props => props.width};
  background-color: var(--green-5);
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 27px 20px;
  margin-bottom: 27px;

  .magazine-download--logo {
    margin-top: 5px;
  }
  .digital-asset-title {
    font-family: 'Sofia Pro';
    font-weight: 900;
    font-size: 25px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.02em;
    color: var(--white-color);
  }
  a {
    width: 100%;
  }
  .magazine-download--button {
    width: 100%;
    margin-top: 20px;
    padding: 10px;
    font-weight: normal;
    font-size: 16px;
    box-shadow: 0px 11.5344px 23.0688px rgba(0, 0, 0, 0.1);
  }
  .digital-asset-container {
    max-width: 180px;
  }
  .digital-asset-container img {
    width: 100%;
  }
`;

const Title = styled.div`
  margin-top: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.02em;
  color: var(--white-color);
`;
